// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"544":"f5c339a70e7b1465c609","873":"13cf45dc6717be7ff5fd"}[chunkId] + ".css";
};